import React from 'react'
import PropTypes from 'prop-types'
import UpgradeMembershipInfo from './UpgradeMembershipInfo'

const UpgradeMembershipOverlay = ({ fontSize = 'normal' }) => {
  return (
    <div
      style={{
        position: 'absolute',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        top: 0,
        zIndex: 1111,
        left: 0,
        right: 0,
        bottom: 0,
        paddingTop: '5%',
        paddingBottom: '5%',
        // @todo need to fix it for small height sections like
        // when we have less data in section and the section height is
        // not enough to show the upgrade membership info
        maxHeight: fontSize === 'small' ? '100%' : 'unset',
        overflowY: fontSize === 'small' ? 'auto' : 'unset',
      }}
    >
      <UpgradeMembershipInfo fontSize={fontSize} />
    </div>
  )
}

UpgradeMembershipOverlay.propTypes = {
  fontSize: PropTypes.string.isRequired,
}

export default UpgradeMembershipOverlay
